export const SearchIcon = (): JSX.Element => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.78 18.78">
      <g fill="none" strokeMiterlimit="10" strokeWidth="1.5">
        <path d="M10.25 11.25l7 7"></path>
        <circle cx="6.75" cy="6.75" r="6"></circle>
      </g>
    </svg>
  </>
);
